import React from "react";
import {Redirect, Route, Switch} from "react-router-dom";
import addUser from "../../containers/User/Add/index";
import viewUser from "../../containers/User/View/index";

const Components = ({match}) => (
  <Switch>
    <Redirect exact from={`${match.url}/`} to={`${match.url}/view`}/>
    <Route path={`${match.url}/add`} component={addUser}/>
    <Route path={`${match.url}/edit/:id`} component={addUser}/>
    <Route path={`${match.url}/view`} component={viewUser}/>
  </Switch>
);

export default Components;